<div class="dropdown-container">
  <mat-accordion [multi]="true">
    @for (key of dropdownResourceKeys; track $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="dropdown-title">
              {{ dropdownSettingsResources[key].name }}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="dropdown-table">
          <app-records-table-container
            [resourceParams]="dropdownSettingsResources[key]"
            [isFullHeight]="false"
          />
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>

